import React, { Fragment, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ActionButton, checkoutUrl } from './ActionButton';
function useCountdown() {
  const [seconds, setSeconds] = useState(23 * 3600 + 55 * 60 + 21);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(value => String(value).padStart(2, '0'));
}
interface PricingProps {
  showAnchor?: boolean;
}
export function Pricing({
  showAnchor = false
}: PricingProps) {
  const [hours, minutes, seconds] = useCountdown();
  return <section id={showAnchor ? 'pricing' : undefined} className="bg-brand-dark" data-id="element-94" data-mp="20sv6oho9bevp">
      <div className="bg-[#1c0909] px-4 py-16 sm:py-20" data-id="element-95" data-mp="3h6v6ztr0l6jh">
        <div className="mx-auto max-w-4xl text-center" data-id="element-96" data-mp="3h5jun5ji6qgr">
          <h2 className="font-display text-xl font-bold sm:text-2xl" data-id="element-97" data-mp="3c932m096nrye">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
          <div className="mt-6 flex justify-center gap-3 sm:gap-6" data-id="element-98" data-mp="3vz72a1ghsvrl">
            {[[hours, 'HS'], [minutes, 'MIN'], [seconds, 'SEG']].map(([value, label], index) => <Fragment key={label} data-id="element-99" data-mp="9rpbzpzdx7wq" data-mpi={index}>
                <div data-id="element-100" data-mp="9sry7klrim6b">
                  <p className="font-display text-5xl font-bold text-red-500 sm:text-7xl" data-id="element-101" data-mp="9q5w40hn4yvh">{value}</p>
                  <p className="text-xs tracking-[.2em] text-slate-400" data-id="element-102" data-mp="eoz81oha4htj">{label}</p>
                </div>
                {index < 2 && <span className="pt-2 font-display text-4xl text-red-500 sm:text-6xl" data-id="element-103" data-mp="3i7si3raumoiy">:</span>}
              </Fragment>)}
          </div>
          <p className="mt-6 text-slate-400" data-id="element-104" data-mp="3n63qrypeqszl">
            Después sube. <b className="text-white" data-id="element-105" data-mp="3rxv8rkuhzqe4">No vuelve.</b>
          </p>
          <div className="mx-auto mt-5 max-w-md rounded-xl border border-red-500/20 bg-brand-ink p-4 text-left" data-id="element-106" data-mp="3rz6bdhc7is3n">
            <div className="flex justify-between text-sm font-medium text-red-400" data-id="element-107" data-mp="2ugd8ddgqt4xo">
              <span data-id="element-108" data-mp="2zfpyq86tou50">Cupos al precio de lanzamiento</span>
              <span data-id="element-109" data-mp="2rg3525fx02oi">Quedan pocos</span>
            </div>
            <div className="mt-3 h-2.5 overflow-hidden rounded-full bg-slate-800" data-id="element-110" data-mp="2res3mc9xz70k">
              <div className="h-full w-[72%] rounded-full bg-red-500" data-id="element-111" data-mp="2mhi4g4wr3gzj" />
            </div>
            <p className="mt-2 text-right text-xs text-slate-500" data-id="element-112" data-mp="3164up1nx1t5j">72% de los cupos ya tomados</p>
          </div>
        </div>
      </div>

      <div className="px-4 py-16 sm:py-24" data-id="element-113" data-mp="28i0ma8dyn1z5">
        <div className="mx-auto max-w-2xl" data-id="element-114" data-mp="28j20glq9w4l3">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-115" data-mp="28jtsjmknvk6m">
            TU SISTEMA COMPLETO
          </h2>
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-8 rounded-3xl border-2 border-brand-green bg-brand-ink p-6 shadow-[0_0_30px_rgba(22,163,74,.13)] sm:p-9" data-id="element-116" data-mp="2igpu18c5761o">
            <div className="flex flex-col gap-4 sm:flex-row sm:justify-between" data-id="element-117" data-mp="9udy4r1spjr">
              <div data-id="element-118" data-mp="59gschim4bu5">
                <h3 className="font-display text-lg font-bold text-brand-light" data-id="element-119" data-mp="59zzr4amzhtx">
                  🌿 SISTEMA INFORMACIÓN BAJO CONTROL™
                </h3>
                <p className="mt-1 text-sm text-slate-400" data-id="element-120" data-mp="3nh684aqrnjh0">
                  3 Volúmenes + 5 Bonos · Acceso inmediato
                </p>
                <p className="mt-3 text-sm text-brand-light" data-id="element-121" data-mp="j0d6j3bskqho">
                  Todo el sistema en PDF + 5 bonos estratégicos de regalo.
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-122" data-mp="a8jlb3lbirlr">
                <p className="text-slate-500 line-through" data-id="element-123" data-mp="a7rxiexypy61">$65.000</p>
                <p className="font-display text-4xl font-bold text-brand-light" data-id="element-124" data-mp="e9n33vmxexpm">$19.990</p>
                <p className="text-xs text-slate-400" data-id="element-125" data-mp="11z7kwb7cfoxb">ARS</p>
              </div>
            </div>
          </motion.div>
          <ActionButton className="mt-7" href={checkoutUrl} showTrust data-id="element-126" data-mp="16rhi8casfr9m">
            🧠 QUIERO MI SISTEMA AHORA
          </ActionButton>
        </div>
      </div>
    </section>;
}